import { render, staticRenderFns } from "./videoEdit.vue?vue&type=template&id=9fa32c70&"
import script from "./videoEdit.vue?vue&type=script&lang=js&"
export * from "./videoEdit.vue?vue&type=script&lang=js&"
import style0 from "./videoEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports